import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getVoucherSum(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_VOUCHER_SUM}${q}`);
}

function getVoucherTotal(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_VOUCHER_RECORD}${q}`);
}

function getInvoice(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_INVOICE}${q}`);
}

function getPurchaseOrders(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_PURCHASE_ORDER}${q}`);
}

function getPayrolls(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_PAYROLL}${q}`);
}

export default {
  getVoucherSum,
  getVoucherTotal,
  getInvoice,
  getPurchaseOrders,
  getPayrolls,
};
